import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";

export const FAQS = [
  {
    q: "لمبة حساس الكفرات مضيئة في الطبلون، ما السبب؟",
    a: "قد يكون السبب انخفاض ضغط أحد الإطارات فعليًا، أو تلف حساس، أو نفاد بطاريته، أو حاجة النظام لإعادة برمجة بعد تبديل الكفرات. الفحص بجهاز قراءة الحساسات يحدد السبب بدقة.",
  },
  {
    q: "هل يلزم فك الكفر بالكامل لاستبدال الحساس؟",
    a: "في أغلب الحالات يُفك الإطار جزئيًا من جهة الصمام للوصول إلى الحساس واستبداله، ثم يُعاد التركيب والترصين وتعبئة الهواء وبرمجة الحساس.",
  },
  {
    q: "كم عمر بطارية حساس TPMS؟",
    a: "يتراوح العمر الافتراضي غالبًا بين 5 إلى 7 سنوات حسب النوع والاستخدام. البطارية مدمجة وغير قابلة للاستبدال في معظم الأنواع، لذا يُستبدل الحساس كاملًا عند نفادها.",
  },
  {
    q: "ما الفرق بين تردد 433MHz و315MHz؟",
    a: "هما ترددان لاسلكيان شائعان تستخدمهما الشركات المصنعة لإرسال بيانات الحساس. سيارتك تدعم ترددًا محددًا، لذا يجب مطابقة تردد الحساس مع نظام السيارة قبل التركيب.",
  },
  {
    q: "هل يمكن برمجة حساس بديل على سيارتي؟",
    a: "كثير من الحساسات البديلة والقابلة للبرمجة تدعم موديلات واسعة، لكن التوافق يعتمد على السيارة وسنة الصنع ونوع النظام. أرسل لنا بيانات سيارتك عبر واتساب لنؤكد لك الخيار المناسب.",
  },
  {
    q: "هل تظهر قراءة الضغط مباشرة بعد تركيب حساس جديد؟",
    a: "تحتاج معظم السيارات إلى إجراء برمجة أو إعادة تعلم (Relearn) بعد تركيب الحساس حتى تتعرف عليه وحدة السيارة وتظهر القراءات بشكل صحيح.",
  },
];

export const FaqAccordion = ({ heading = true }) => (
  <section data-testid="faq-section" className="bg-[#F1F5F9] py-20 sm:py-28 text-slate-900">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      {heading && (
        <SectionHeading
          light
          align="center"
          eyebrow="FAQ"
          title="الأسئلة الشائعة"
          desc="إجابات مباشرة عن أكثر ما يسأل عنه ملاك السيارات بخصوص حساسات الكفرات."
        />
      )}
      <Reveal>
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i + 1}`}
              className="bg-white border border-slate-200 rounded-2xl px-5 sm:px-6 data-[state=open]:border-red-300 data-[state=open]:shadow-[0_8px_30px_rgba(220,38,38,0.08)] transition-all"
            >
              <AccordionTrigger className="text-right font-display font-semibold text-sm sm:text-base hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 text-sm leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
